import moment from 'moment'

/**
 * DHL plannedShippingDateAndTime in Lagos time ('YYYY-MM-DDTHH:mm:ss GMT+01:00').
 * The quote and the booking must send the same value, or the customer is
 * quoted for one shipping date and DHL bills another (e.g. across a surcharge
 * start date).
 *
 * - With a pickup date: that day at 12:00, inside DHL business hours.
 * - Without: the current time; the backend rolls after-hours to the next
 *   business day.
 */
export const plannedShippingDate = (pickupDate?: string | Date) =>
  pickupDate
    ? `${moment(pickupDate).format('YYYY-MM-DD')}T12:00:00 GMT+01:00`
    : `${moment().utcOffset(60).format('YYYY-MM-DDTHH:mm:ss')} GMT+01:00`
